/* global CONFIG: true */
// Export the root config
export default CONFIG;
